import { useNavigate } from '@tanstack/react-router';
import { Formik } from 'formik';

import { useOrderEdit } from '../hooks/useOrderEdit';

import { OrderEditForm } from './OrderEditForm';
import { mapToFuelOrderRequestObject } from '../mapToFuelOrderRequestObject';

export const OrderEditFormikWrapper = (props) => {
    const orderEditMutation = useOrderEdit();
    const navigate = useNavigate();

    const validate = (values) => {
        const errors = {};

        if (!values.eta) {
            errors.eta = 'REQUIRED';
        }

        if (!values.etd) {
            errors.etd = 'REQUIRED';
        }

        if (values.items.every((item) => item.deleted) || values.items.some((item) => !item.isComplete())) {
            errors.invalidProducts = true;
        }

        return errors;
    };

    const onSubmit = async (values) => {
        const orderEditRequestMessage = mapToFuelOrderRequestObject(values, values.state);

        await orderEditMutation.mutateAsync({
            orderId: values.id,
            order: orderEditRequestMessage,
        });

        navigate({ to: '/fuel/order/$id', params: { id: values.id } });
    };

    return (
        <Formik
            initialValues={props.data}
            validateOnMount
            validate={validate}
            component={OrderEditForm}
            onSubmit={onSubmit}
        />
    );
};
